<ng-container *ngIf="!error; else errorTpl">
  <ng-container *ngIf="profile$ | async as p; else loadingTpl">
    <mat-card class="profile-card">
      <div class="header">
        <div class="title">
          <h2>Profil</h2>
<!--          <div class="subtitle" *ngIf="p.isAdmin">Administrator</div>-->
        </div>
      </div>

      <div class="row">
        <div class="label">Name</div>
        <div class="value">
          {{ p.firstName }} {{ p.lastName }}

          <button class="icon-button" (click)="onChangeName(); $event.stopPropagation()" aria-label="Name ändern">
            <img src="assets/images/edit.svg" alt="Bearbeiten" />
          </button>

          <mat-progress-spinner
            *ngIf="isUpdating"
            mode="indeterminate"
            diameter="16"
            strokeWidth="2"
            class="inline-spinner">
          </mat-progress-spinner>
        </div>
      </div>

      <div class="row">
        <div class="label">E-Mail</div>
        <div class="value">
          {{ p.email }}
<!--          <button class="icon-button" (click)="onChangeName()" aria-label="Name ändern">-->
<!--            <img src="assets/images/edit.svg" alt="Edit" />-->
<!--          </button>-->
        </div>
      </div>

      <div class="actions">
        <button mat-stroked-button (click)="onChangePassword()">
          <span>Passwort ändern</span>
        </button>
      </div>
    </mat-card>
  </ng-container>
</ng-container>

<ng-template #loadingTpl>
  <mat-card class="profile-card">
    <div class="loading">Lade Profil…</div>
  </mat-card>
</ng-template>

<ng-template #errorTpl>
  <mat-card class="profile-card">
    <div class="error">{{ error }}</div>
  </mat-card>
</ng-template>
